import React, { useState } from 'react';
import { connect } from 'react-redux';
// import { StyledText } from '../../../../components/styledComponents/components';
import AtomicPopup from 'src/components/AtomicPopup';
import { useIntl } from "react-intl";
import AlertInfo from "../../assets/svg/AlertInfo";
import { Button, Checkbox, Flex } from 'antd';

const Disclaimer = ({ onCancel, onAgree }) => {
  const intl = useIntl();

  const [isAgreed, setIsAgreed] = useState(false);

  const handleAgree = () => {
    if (!isAgreed) {
      alert('알림: 위 사항을 확인해주세요.');
      return;
    }
    onAgree();
  };

  return (
    <AtomicPopup open={true}
      title={<Flex align='center' gap={10}>
        <AlertInfo width={24} height={24} />
        {intl.formatMessage({ id: 'stream.importantNotice' })}
      </Flex>}
      titleStyle={{ fontSize: 20, fontWeight: 700 }}
      centered
      footer={<div style={{
        height: 1,
      }}></div>}
      maskClosable={false}
      closeIcon={false}
      width={533}

    >

      <div style={styles.container}>
        <div style={styles.content}>
          <div style={styles.title}>
            {intl.formatMessage({ id: 'vlink.description.disclaimer' })}
          </div>

          <div style={styles.checkboxContainer} >
            <Checkbox
              style={styles.checkboxText}
              checked={isAgreed}
              onChange={e => setIsAgreed(e.target.checked)}
            >
              {intl.formatMessage({ id: 'vlink.description.agreeDisclaimer' })}
            </Checkbox>
          </div>
        </div>

        <div style={styles.buttonContainer}>
          <Button
            style={{ ...styles.button, ...styles.cancelButton }}
            onClick={onCancel}
          >
            {intl.formatMessage({ id: 'vlink.common.cancel' })}
          </Button>

          <Button
            style={{
              ...styles.button,
              ...styles.agreeButton,
              color: isAgreed ? "#fff" : '#fff3',
              backgroundColor: isAgreed ? "#DF043A" : '#B9B8B9',
            }}
            disabled={!isAgreed}
            onClick={handleAgree}
          >
            {intl.formatMessage({ id: 'common.agreeAndContinue' })}
          </Button>
        </div>
      </div>
    </AtomicPopup>

  );
};

const styles = {
  container: {
    height: '200px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    // padding: 20,
    position: 'relative',
  },
  content: {
    marginBottom: 32,
    textAlign: 'center',
  },
  title: {
    fontSize: 16,
    fontWeight: 400,
    color: '#181818',
    lineHeight: '24px',
    whiteSpace: 'pre-line'
  },
  checkboxContainer: {
    display: 'flex',
    justifyContent: 'center',
    cursor: 'pointer',
    padding: "18px 0"
  },
  checkboxText: {
    fontSize: 14,
    color: '#2C2E33',
  },
  buttonContainer: {
    position: 'absolute',
    height: 40,
    bottom: 20,
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
  },
  button: {
    // padding: '16px 26px',
    height: 40,
    borderRadius: 4,
    border: 'none',
    color: '#fff',
    fontSize: 16,
    minWidth: 80,
  },
  cancelButton: {
    backgroundColor: '#4F4F4F',
  },
  agreeButton: {
    backgroundColor: '#B9B8B9',
  },
};

// Redux 연결 (선택사항)
const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Disclaimer);
